export enum RouteHeaderName {
  Dashboard = "Dashboard",
  Alerts = "Alerts",
  Bookings = "Bookings",
  Calendar = "Calendar",
  Theaters = "Theaters",
  Seats = "Seats",
  Settings = "Settings",
  Payments = "Payments",
  Users = "Users",
  Content = "Content",
  ImportBookings = "Import",
  Logs = "Logs",
  Backup = "Backup",
  BannerSettings = "Banner Settings",
  VolcanoBannerSettings = "Volcano Banner Settings",
  PromoCodes = "Promo Codes",
}
